import { render, staticRenderFns } from "./InnerList.vue?vue&type=template&id=21d87f6a&scoped=true"
import script from "./InnerList.vue?vue&type=script&lang=js"
export * from "./InnerList.vue?vue&type=script&lang=js"
import style0 from "./InnerList.vue?vue&type=style&index=0&id=21d87f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d87f6a",
  null
  
)

export default component.exports